import { render, staticRenderFns } from "./AttachmentEditView.vue?vue&type=template&id=31d9af5e&scoped=true"
import script from "./AttachmentEditView.vue?vue&type=script&lang=js"
export * from "./AttachmentEditView.vue?vue&type=script&lang=js"
import style0 from "./AttachmentEditView.vue?vue&type=style&index=0&id=31d9af5e&prod&scoped=true&lang=css"
import style1 from "./AttachmentEditView.vue?vue&type=style&index=1&id=31d9af5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9af5e",
  null
  
)

export default component.exports